import { PartyContactMechanismPurposes } from './party-contact-mechanism-purposes.model';
import { ContactMechanisms } from './contact-mechanisms.model';
import { PartyRoleTypes } from './party-role-types.model';
import { STUDENT } from '../../common-components/multi-select-coe-student/coe-related-student';
export class PartyContactMechanisms {
    ID?: number;
    PARTIES_ID?: number;
    PARTY_ROLE_TYPES_ID?: number;
    CONTACT_MECHANISMS_ID?: number;
    MERGED_RECORD?: number;
    CREATED_BY?: string;
    CREATED_DATE?: Date; // "/Date(1482326259893)/",
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    CONTACT_MECHANISMS?: ContactMechanisms;
    STANDARDIZED_POSTAL_ADDRESSES?: string[];
    TELEPHONE_NUMBERS?: string[];
    CONTACT_PERSONS?: string[];
    PARTY_CONTACT_MECHANISM_PURPOSES?: PartyContactMechanismPurposes[];
    PARTY_ROLE_TYPES?: PartyRoleTypes;
    RELATED_PARTY_CONTACT_MECHANISM_STUDENTS?: STUDENT[];
}
